import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { HeaderComponent } from './header/header.component';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserCardComponent } from './user-card/user-card.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { NoResultComponent } from './no-result/no-result.component';
import { ScrollTopBtnComponent } from './scroll-top-btn/scroll-top-btn.component';
import { CardsRowComponent } from './cards-row/cards-row.component';
import { DataCardComponent } from './cards-row/data-card/data-card.component';
import { TableComponent } from './table/table.component';
import { TabsComponent } from './tabs/tabs.component';
import { RouterModule } from '@angular/router';
import { RedirectCardComponent } from './redirect-card/redirect-card.component';
import { FooterComponent } from './footer/footer.component';
import { ButtonComponent } from './article-blocks/button/button.component';
import { FullImageComponent } from './article-blocks/full-image/full-image.component';
import { FullTextComponent } from './article-blocks/full-text/full-text.component';
import { PdfReaderComponent } from './article-blocks/pdf-reader/pdf-reader.component';
import { SocialsComponent } from './article-blocks/socials/socials.component';
import { TextImageComponent } from './article-blocks/text-image/text-image.component';
import { TitleComponent } from './article-blocks/title/title.component';
import { VideoComponent } from './article-blocks/video/video.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { ProgressCircleComponent } from './progress-circle/progress-circle.component';

@NgModule({
  declarations: [
    HeaderComponent,
    ProgressCircleComponent,
    UserCardComponent,
    SpinnerComponent,
    NoResultComponent,
    ScrollTopBtnComponent,
    CardsRowComponent,
    DataCardComponent,
    TableComponent,
    TabsComponent,
    RedirectCardComponent,
    FooterComponent,
    ButtonComponent,
    FullImageComponent,
    FullTextComponent,
    PdfReaderComponent,
    SocialsComponent,
    TextImageComponent,
    TitleComponent,
    VideoComponent,
    FileUploadComponent
  ],
  exports: [
    HeaderComponent,
    UserCardComponent,
    SpinnerComponent,
    NoResultComponent,
    ScrollTopBtnComponent,
    CardsRowComponent,
    DataCardComponent,
    TableComponent,
    TabsComponent,
    RedirectCardComponent,
    FooterComponent,
    ButtonComponent,
    FullImageComponent,
    FullTextComponent,
    PdfReaderComponent,
    SocialsComponent,
    TextImageComponent,
    TitleComponent,
    VideoComponent,
    FileUploadComponent,
    ProgressCircleComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    EditorModule
  ]
})
export class ComponentsModule {}
